/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { comparisonsControllerAssessChange } from "./comparisonsControllerAssessChange";
import { comparisonsControllerClearAssessment } from "./comparisonsControllerClearAssessment";
import { comparisonsControllerDownload } from "./comparisonsControllerDownload";
import { comparisonsControllerGetById } from "./comparisonsControllerGetById";
import { comparisonsControllerGetDownloadUrl } from "./comparisonsControllerGetDownloadUrl";
import { comparisonsControllerListByRootFileId } from "./comparisonsControllerListByRootFileId";
import { comparisonsControllerListChanges } from "./comparisonsControllerListChanges";
import { comparisonsControllerRemove } from "./comparisonsControllerRemove";
import { comparisonsControllerRename } from "./comparisonsControllerRename";
import { comparisonsControllerStart } from "./comparisonsControllerStart";

export function comparisonsService() {
  return { comparisonsControllerListByRootFileId, comparisonsControllerStart, comparisonsControllerDownload, comparisonsControllerGetDownloadUrl, comparisonsControllerListChanges, comparisonsControllerGetById, comparisonsControllerRemove, comparisonsControllerRename, comparisonsControllerAssessChange, comparisonsControllerClearAssessment }
}